module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 5.68ba13a1.mp3";